import { render } from "./gantt.vue?vue&type=template&id=2900ac60"
import script from "./gantt.vue?vue&type=script&lang=js"
export * from "./gantt.vue?vue&type=script&lang=js"

import "./gantt.vue?vue&type=style&index=0&id=2900ac60&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__